
import { BrowserRouter, useLocation } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { useEffect } from "react";
import { trackPageView } from "./utils/metaPixel";

function RouteTracker() {
  const location = useLocation();

  useEffect(() => {
    // Guard against possible errors inside the tracking utility
    try {
      trackPageView();
    } catch (err) {
      console.error("Failed to track page view:", err);
    }
  }, [location.pathname]);

  return null;
}

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <RouteTracker />
        <AppRoutes />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
